/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import styled from "styled-components";

/**
 * Flex column styles.
 */
export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1px;
`;

/**
 * Styles for the overall navigation container.
 */
export const NavigationContainer = styled(FlexColumn)`
  background-color: #ebebeb;
  border-right: 1px solid #c8c8c8;
  justify-content: space-between;
  max-width: 200px;
  min-width: 200px;
  -webkit-transition: max-width 0.2s ease-in-out;
  -moz-transition: max-width 0.2s ease-in-out;
  -o-transition: max-width 0.2s ease-in-out;
  transition: max-width 0.2s ease-in-out;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
